import { Icon } from '@aibees/shared/components/icon';
import { Chip } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { InputTagsProps as Props } from './types';

export const InputTags = memo(({ action, label, index }: Props) => {
  return (
    <Chip
      sx={SX.chip}
      variant="outlined"
      label={label}
      onDelete={action({ index }).onDelete}
      tabIndex={action({ index }).tabIndex}
      deleteIcon={<Icon name="close" size={18} sxx={SX.deleteIcon} />}
    />
  );
});

InputTags.displayName = 'InputTags';
